import { combineReducers } from "@reduxjs/toolkit";
import displayTreatment from "./displayTreatmentSlice";

const reducer = combineReducers({
  displayTreatment,
});

export default reducer;
